import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useSelector, useDispatch } from 'react-redux';
import { Button } from 'reactstrap';

import { createBCDataset } from '../../../../../actions/synchronisationActions';

// Migrated from redux-form to react-hook-form. withRouter was unused (the
// component takes storeId/sourceId as props), so it's dropped.
export const BCDatasetForm = ({ storeId, sourceId }) => {
  const dispatch = useDispatch();
  const resetForm = useSelector((state) => state.sync.bcDataset.resetForm);
  const { register, handleSubmit, reset } = useForm({ defaultValues: {} });

  useEffect(() => {
    if (resetForm) reset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resetForm]);

  const onSubmit = (values) => {
    if (storeId) dispatch(createBCDataset(storeId, values, sourceId));
  };

  return (
    <tr>
      <td>
        <input {...register('datasetName')} className="form-control" type="text" style={{ width: '100%' }} />
      </td>
      <td>
        <input {...register('operation')} className="form-control" type="text" style={{ width: '100%' }} />
      </td>
      <td>
        <input {...register('changesOperation')} className="form-control" type="text" style={{ width: '100%' }} />
      </td>
      <td>
        <input {...register('idField')} className="form-control" type="text" style={{ width: '100%' }} />
      </td>
      <td>
        <input {...register('timestampField')} className="form-control" type="text" style={{ width: '100%' }} />
      </td>
      <td>
        <input {...register('cbaTableID')} className="form-control" type="text" style={{ width: '100%' }} />
      </td>
      <td />
      <td>
        <div className="d-flex flex-row justify-content-end">
          <Button color="primary" type="submit" onClick={handleSubmit(onSubmit)}>
            Save
          </Button>
          <Button color="secondary" type="button" className="ms-2" onClick={() => reset()}>
            Reset
          </Button>
        </div>
      </td>
    </tr>
  );
};

export default BCDatasetForm;
